import renderDetails from 'core/controllerPlans/renderDetails'
import setStickyDetailsMenu from '../setStickyDetailsMenu'
import scrollTo from 'core/DOM/scrollTo'

function goToAnchor() {
  const urlAnchor = document.URL.split('#').length > 1 ? document.URL.split('#')[1] : null
  if (!urlAnchor) {
    return
  }

  const anchor = $(`#${urlAnchor}`)

  if (anchor.length > 0) {
    const anchorTop = anchor.offset().top - 125
    scrollTo(anchorTop)
  }
}

function setInteractionsForDetails(result) {
  setStickyDetailsMenu(result)
  setTimeout(goToAnchor, 100)
}

function configureDetails(state) {
  return renderDetails(state).then(setInteractionsForDetails)
}

export default configureDetails
